import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import  { DistinguishingDetailDefinitionView } from "./distinguishingDetailDefinition-view"
import { DistinguishingDetailValueUpdaterViewModel, singleValue } from "./distinguishingDetailValueUpdater/distinguishingDetailValueUpdater-viewModel";

export class DistinguishingDetailDefinitionViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.details = ObservableArray.create<DistinguishingDetailWrapper>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistinguishingDetailDefinitionView();
    }
    public getTypeId(): string {
        return "VM-B22018E9-A59E-428D-8B72-84F7DFA2CCDF"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set details(v: ObservableArray<DistinguishingDetailWrapper>) { this._details = v; } public get details(): ObservableArray<DistinguishingDetailWrapper> { return this._details;} private _details: ObservableArray<DistinguishingDetailWrapper>;

    async refresh(){
        try {
            this.isLoading = true;
            let dtoResult = await ServerConnection.callServer('Complex/AccountingServices/GetAllDistinguishingDetails',{});
            let detailDtos = dtoResult.Details;
            let detailsMap : {[id:string]:DistinguishingDetailWrapper}={}
            let details = detailDtos.map(x=>{
                let r = new DistinguishingDetailWrapper(this,false);
                r.id = x.Id;
                r.name = x.Name;
                detailsMap[r.id]=r;
                return r;
            });
            detailDtos.forEach(x => {
                let childIds:string[]=x.ChildDistinguishingDetails
                let childDetails = childIds.map(q=>detailsMap[q]);
                detailsMap[x.Id].addChildren(...childDetails);
            });
            this.details.update(...details);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public getUpdateDto():any{
        return new DistinguishingDetailUpdater().getUpdateDto(this.details);
    }
    async update(){
        try {
            this.isLoading = true;
            await new DistinguishingDetailUpdater().update(this.details);
            
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    addNew(){
        this.details.push(new DistinguishingDetailWrapper(this,true));
    }
}


class DistinguishingDetailUpdater implements IDistinguishingDetailVisitor {
    private atomicDetails:AtomicDetail[]=[];
    private complexDetails:ComplexDetail[]=[];

    VisitAtomicDetail(detail: AtomicDetail, parameter: any) {
        this.atomicDetails.push(detail);
    }
    VisitComplexDetail(detail: ComplexDetail, parameter: any) {
        this.complexDetails.push(detail);
    }

    public getUpdateDto(details:ObservableArray<DistinguishingDetailWrapper>){
        details.forEach(x=>x.detail.accept(this,null));
        return {
            AtomicDetails:this.atomicDetails.map(x=>{ 
                return {
                    Id:x.wrapper.id,
                    ClientProvidedId:x.wrapper.index,
                    Name:x.wrapper.name,
                    NewValues:x.newOnes.map(q=>{
                        return {
                            Name:q.name,
                            Code:q.code
                        };
                    }),
                    UpdatingValues:x.updatedOnes.map(q=>{
                        return {
                            Id:q.id,
                            Name:q.name,
                            Code:q.code
                        }
                    }),
                    RemovingValues:x.deletedOnes.map(x=>x.id)
                }
            }),
            ComplexDetails:this.complexDetails.map(x=>{
                return {
                    Id:x.wrapper.id,
                    ClientProvidedId:x.wrapper.index,
                    Name:x.wrapper.name,
                    Children:x.values.map(q=>{
                        return {
                            Id:q.child.id,
                            ClientProvidedId:q.child.index
                        }
                    })
                }
            })
        }
    }
    async update(details:ObservableArray<DistinguishingDetailWrapper>){
        ServerConnection.callServer('Complex/AccountingServices/UpdateDistinguishingDetails',this.getUpdateDto(details))
    }
}
class DistinguishingDetailFactory implements IDetailChildVisitor{
    visitAtomicValue(value: AtomicValue, parameter: any):AtomicDetail {
        return new AtomicDetail(this.parent);
    }
    visitDistinguishingDetail(value: DistinguishingDetailWrapper, parameter: any):ComplexDetail {
        return new ComplexDetail(this.parent);
    }
    private parent:DistinguishingDetailWrapper;
    getDetailFor(value:IDetailChild,parent:DistinguishingDetailWrapper):DistinguishingDetail{
        this.parent = parent;
        return value.accept(this,null);
    }
}
export class DistinguishingDetailWrapper extends ViewModel implements IDetailChild{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,noLoadedData:boolean) {
        super(parent);
        this.updateIndex();
        if(noLoadedData==null){
            noLoadedData = false;
        }
        this.revertToAtomicDetail();
        if(noLoadedData==false)
            (<AtomicDetail>this.detail).isValuesLoaded = false;
    }
    private revertToAtomicDetail(){
        let detail = new AtomicDetail(this);
        detail.isValuesLoaded = true;
        this.detail = detail;
        
    }
    private static lastAssignedIndex:number=0;
    private updateIndex(){
        DistinguishingDetailWrapper.lastAssignedIndex+=1;
        this.index = DistinguishingDetailWrapper.lastAssignedIndex;
    }

    public set detail(v: DistinguishingDetail) { 
        this._detail = v; 
        if(v){
            this.shallShowValues = v.shallShowValues;
        }else{
            this.shallShowValues = false;
        }
    } public get detail(): DistinguishingDetail { return this._detail;} private _detail: DistinguishingDetail;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set shallShowValues(v: boolean) { this._shallShowValues = v; } public get shallShowValues(): boolean { return this._shallShowValues;} private _shallShowValues: boolean;

    handleMessage(message:ViewModelMessage){
        if(message instanceof DragDropPossibilityChecker && 
            message.dragged instanceof DistinguishingDetailWrapper && 
            message.droppedTo instanceof DistinguishingDetailWrapper){
                if(message.droppedTo.detail.canAcceptChild(message.dragged) || message.droppedTo.isDetailReplacable())
                    return message.createAllowanceResponse("True");
                else 
                    return message.createRejectResponse();
        }else if(message instanceof DropAppliedViewModelMessage && 
            message.dragged instanceof DistinguishingDetailWrapper && 
            message.droppedTo instanceof DistinguishingDetailWrapper){
                message.droppedTo.addChildren(message.dragged);
                return null;
        }else{
            return super.handleMessage(message);
        }

    }
    isDetailReplacable(){
        return this.detail.canBeChanged();
    }
    addChildren(...children: IDetailChild[]) {
        if(children.every(x=>this.detail.canAcceptChild(x))){
            this.detail.addChildren(...children);
        }else if(this.isDetailReplacable()){
            this.detail = new DistinguishingDetailFactory().getDetailFor(children[0],this);
            if(children.every(x=>this.detail.canAcceptChild(x))){
                this.detail.addChildren(...children);
            }else{
                throw "children does not comform to each other";
            }        
        }else{
            throw "this kind of child can not be added";
        }
    }
    accept(visitor: IDetailChildVisitor, parameter: any) {
        return visitor.visitDistinguishingDetail(this,parameter);
    }
    onTypeChangingAllowed() {
        this.revertToAtomicDetail();
    }
     
}

export abstract class DistinguishingDetail extends ViewModel{
    constructor(parent:DistinguishingDetailWrapper) {
        super(parent);
        this.wrapper = parent;
    }
    public wrapper : DistinguishingDetailWrapper;
    public set shallShowValues(v: boolean) { this._shallShowValues = v; } public get shallShowValues(): boolean { return this._shallShowValues;} private _shallShowValues: boolean;
    abstract canBeChanged():boolean;
    abstract canAcceptChild(child:IDetailChild):boolean;
    abstract addChildren(...children: IDetailChild[]);

    abstract accept(visitor:IDistinguishingDetailVisitor,paramter:any):any;
}

export class AtomicDetail extends DistinguishingDetail{

    public getTypeId(): string {return 'atomic-detail';}
    public GetDefaultView(): View<ViewModel> {return null;}
    
    constructor(parent:DistinguishingDetailWrapper) {
        super(parent);
        this.values = ObservableArray.create<AtomicValue>();    
        this.isValuesLoaded = false;
        this.shallShowValues = true;
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set values(v: ObservableArray<AtomicValue>) { this._values = v; } public get values(): ObservableArray<AtomicValue> { return this._values;} private _values: ObservableArray<AtomicValue>;
    
    public newOnes:ObservableArray<AtomicValue>=ObservableArray.create<AtomicValue>();
    public updatedOnes:ObservableArray<AtomicValue>=ObservableArray.create<AtomicValue>();
    public deletedOnes:ObservableArray<AtomicValue>=ObservableArray.create<AtomicValue>();
    
    
    public isValuesLoaded:boolean;

    accept(visitor: IDistinguishingDetailVisitor, paramter: any) {
        return visitor.VisitAtomicDetail(this,paramter);
    }

    canBeChanged():boolean{
        return this.values.length==0;
    }
    canAcceptChild(child: IDetailChild): boolean {
        if(child instanceof AtomicValue){
            return true;
        }
        return false;
    }
    addChildren(...children: IDetailChild[]) {
        if(children.every(x=>x instanceof AtomicValue))
            this.values.push(...<AtomicValue[]>children);
    }

    requestUpdateValues(){
        let viewModel = new DistinguishingDetailValueUpdaterViewModel(this);
        viewModel.loadForDetail(this);
        this.requestShowingPopup(viewModel);
    }

    updateValues(newOnes: ObservableArray<singleValue>, updatedOnes: ObservableArray<singleValue>, deletedOnes: ObservableArray<singleValue>) {
        let newValues = newOnes.map(x=>{
            let r = new AtomicValue(this);
            r.isNew = true;
            r.isUpdated = false;
            r.name = x.name;
            r.code = x.code;
            return r;
        });
        this.values.push(...newValues);
        this.newOnes.push(...newValues);
        
        this.values.remove(...deletedOnes.map(x=>x.relatedValue));
        this.newOnes.remove(...deletedOnes.map(x=>x.relatedValue))
        this.updatedOnes.remove(...deletedOnes.map(x=>x.relatedValue))
        this.deletedOnes.push(...deletedOnes.filter(x=>x.relatedValue.isNew==false).map(x=>x.relatedValue));

        updatedOnes.forEach(x=>{
            x.relatedValue.name = x.name;
            x.relatedValue.code = x.code;
            if(x.relatedValue.isNew==false && x.relatedValue.isUpdated==false){
                this.updatedOnes.push(x.relatedValue);
                x.relatedValue.isUpdated = true;
            }
        });
    }
    

    async getValues():Promise<ObservableArray<AtomicValue>> {
        if(this.isValuesLoaded==false){
            try {
                this.isLoading = true;
                let dtoReuslt = await ServerConnection.callServer('Complex/AccountingServices/GetDistinguishingDetailValues',{
                    DetailIds:[this.wrapper.id]
                });
                this.values.update(...dtoReuslt.Details[0].Values.map(x=>{
                    let r = new AtomicValue(this);
                    r.id = x.Id;
                    r.name = x.Value;
                    r.code = x.Code;
                    r.isNew = false;
                    r.isUpdated = false;
                    return r;
                }));
                this.isValuesLoaded = true;
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
        return Promise.resolve(this.values);
    }
    
}
export class ComplexDetailChildAssignment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    private parentDetail:ComplexDetail;

    public set child(v: DistinguishingDetailWrapper) { this._child = v; } public get child(): DistinguishingDetailWrapper { return this._child;} private _child: DistinguishingDetailWrapper;
    
    constructor(parent:ComplexDetail,value:DistinguishingDetailWrapper) {
        super(parent);
        this.parentDetail = parent;
        this.child = value;
    }
    
    remove(){
        this.parentDetail.removeChild(this);
    }
}
export class ComplexDetail extends DistinguishingDetail{

    public getTypeId(): string {return 'complex-detail';}
    public GetDefaultView(): View<ViewModel> {return null;}

    private parentWrapper:DistinguishingDetailWrapper;
    constructor(parent:DistinguishingDetailWrapper) {
        super(parent);
        this.parentWrapper = parent;
        this.values = ObservableArray.create<ComplexDetailChildAssignment>();    
        this.shallShowValues = false;
    }

    public set values(v: ObservableArray<ComplexDetailChildAssignment>) { this._values = v; } public get values(): ObservableArray<ComplexDetailChildAssignment> { return this._values;} private _values: ObservableArray<ComplexDetailChildAssignment>;
    
    canBeChanged():boolean{
        return this.values.length==0;
    }

    canAcceptChild(child: IDetailChild): boolean {
        if(child instanceof DistinguishingDetailWrapper){
            return true;
        }
        return false;
    }

    addChildren(...children: IDetailChild[]) {
        if(children.every(x=>x instanceof DistinguishingDetailWrapper))
            this.values.push(...children.map(x=>new ComplexDetailChildAssignment(this,<DistinguishingDetailWrapper>x)));
    }

    removeChild(...child:ComplexDetailChildAssignment[]){
        this.values.remove(...child);
        if(this.values.length==0){
            this.parentWrapper.onTypeChangingAllowed();
        }
    }

    accept(visitor: IDistinguishingDetailVisitor, paramter: any) {
        return visitor.VisitComplexDetail(this,paramter);
    }
}

export class AtomicValue extends ViewModel implements IDetailChild{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set isNew(v: boolean) { this._isNew = v; } public get isNew(): boolean { return this._isNew;} private _isNew: boolean;
    public set isUpdated(v: boolean) { this._isUpdated = v; } public get isUpdated(): boolean { return this._isUpdated;} private _isUpdated: boolean;
    
    accept(visitor: IDetailChildVisitor, parameter: any) {
        return visitor.visitAtomicValue(this,parameter);
    }

}



interface IDetailChild{
    accept(visitor:IDetailChildVisitor,parameter:any):any;
}
interface IDetailChildVisitor{
    visitAtomicValue(value:AtomicValue,parameter:any):any;
    visitDistinguishingDetail(value:DistinguishingDetailWrapper,parameter:any):any;
}
interface IDistinguishingDetailVisitor {
    VisitAtomicDetail(detail:AtomicDetail,parameter:any):any;
    VisitComplexDetail(detail:ComplexDetail,parameter:any):any;
}